import { fetchAccountMe, fetchSbpBanks } from "../api/client.js";
import {
  hasMarketplaceJwtCredentials,
  isTelegramWebAppSession,
} from "../lib/wicoopProfileStorage.js";

export function accountNeedsProfileCompletion(me, jumpEnabled) {
  if (!me || typeof me !== "object") return true;
  if (!String(me.first_name || "").trim() || !String(me.last_name || "").trim()) {
    return true;
  }
  if (jumpEnabled) {
    const sid = me.sbp_bank_id;
    if (sid == null || sid === "" || !String(sid).trim()) return true;
  }
  return false;
}

export function profileCompletionPath(returnTo) {
  if (!returnTo) return "/profile/complete";
  return `/profile/complete?returnTo=${encodeURIComponent(returnTo)}`;
}

export async function fetchProfileCompletionRedirect(returnTo) {
  if (!hasMarketplaceJwtCredentials() || !isTelegramWebAppSession()) {
    return null;
  }
  try {
    const [me, sbp] = await Promise.all([fetchAccountMe(), fetchSbpBanks()]);
    if (accountNeedsProfileCompletion(me, !!sbp.jump_enabled)) {
      return profileCompletionPath(returnTo);
    }
  } catch {
    /* ignore */
  }
  return null;
}

export async function navigateAfterAuth(navigate, returnTo) {
  const redirect = await fetchProfileCompletionRedirect(returnTo);
  navigate(redirect || returnTo || "/profile", { replace: true });
}
